import { apiRequest } from './apiClient';

export interface EstimateData {
  orderNo: string;
  title: string | null;
  company: string | null;
  customerName: string;
  phone: string;
  email: string | null;
  shape: string | null;
  quantity: number;
  boxSize: string | null;
  printOption: string | null;
  deadline: string | null;
  shippingMethod: string;
  totalPrice: number;
  revisionFee: number;
  createdAt: string;
  issuedAt: string;
}

// 주문 본인 토큰(proofToken) 또는 관리자 토큰으로 조회한다. 금액이 확정되지 않았으면 409
export function fetchEstimate(orderId: string, token: string): Promise<EstimateData> {
  return apiRequest<EstimateData>(`/api/orders/${orderId}/estimate`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
